<template>
  <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
    <h2 class="mb-10">Formulario de Aumento de plazo</h2>
    <div class="form-group row">
      <label for="empresa" class="col-4 col-form-label">Empresa</label>
      <div class="col-4" data-cy="company">
        <select class="form-control" v-model="formData.empresa" id="empresa">
          <option value="aguasandinas" >Aguas Andinas</option>
          <option value="cordillera">Cordillera</option>
          <option value="manquehue">Manquehue</option>
        </select>
      </div>
    </div>

    <div class="form-group row">
      <label for="titulo" class="col-4 col-form-label">Titulo Destinatario</label>
      <div class="col-4" data-cy="recipient-title">
        <select class="form-control" v-model="formData.tituloDestinatario" id="titulo">
          <option value="sr" >Señor</option>
          <option value="sra">Señora</option>
          <option value="srta">Señorita</option>
        </select>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-6" data-cy="recipient's-name">
        <vs-input
          label="Nombre del destinatario"
          type="text"
          v-model="formData.nombreDestinatario"
          class="w-full"
          id="nombreDestinatario"
        />
      </div>
      <div class="col-6">
        <vs-input
          label="Cargo del destinatario"
          type="text"
          v-model="formData.cargoDestinatario"
          class="w-full"
          id="cargoDestinatario"
          data-cy="recipient-position"
        />
      </div>
    </div>
    <div class="form-group row">
      <div class="col-6"  data-cy="user-step">
        <list-user
          @set-position="setPosition"
          class="w-100"
          autocomplete
          label="Firmante"
          name="userStep"
          v-model="formData.nombreAutor"
          id="nombreAutor"
          ref="author"
        />
      </div>
      <div class="col-6">
        <vs-input
          label="Cargo firmante"
          type="text"
          v-model="formData.cargoAutor"
          class="w-full"
          id="cargoAutor"
          data-cy="signatory-position"
        />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12">
        <vs-input
          label="Referencia"
          class="w-full"
          type="text"
          v-model="formData.referencia"
          id="referencia"
          data-cy="reference"
        />
        <div class="text-right" v-if="hasReference">
          <small v-tooltip="'Contador de caracteres'">
            {{formData.referencia.length}} caracteres
          </small>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12">
        <vs-input
          label="Materia"
          class="w-full"
          type="text"
          v-model="formData.materia"
          name="materia"
          :danger="errors.has('custom-document.materia')"
          :danger-text="errors.first('custom-document.materia')"
          v-validate="'required'"
          data-cy="subject"
        />
        <div class="text-right" v-if="hasMatter">
          <small v-tooltip="'Contador de caracteres'">{{formData.materia.length}} caracteres</small>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12">
        <vs-input
          label="Incluye"
          class="w-full"
          type="text"
          v-model="formData.inc"
          id="inc"
          data-cy="includes"
        />
        <div class="text-right" v-if="hasInc">
          <small v-tooltip="'Contador de caracteres'">{{formData.inc.length}} caracteres</small>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12">
        <label>En atención a vuestro oficio de la referencia, relativo a:</label>
        <vs-textarea
          type="text"
          class="w-full mb-0"
          v-model="formData.motivo"
          v-validate="'required'"
          name="motivo"
          data-cy="reason"
        />
        <div
          v-if="errors.first('custom-document.motivo')"
          class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
          style="height: 32px;">
        <span class="span-text-validation">
          {{errors.first('custom-document.motivo')}}
        </span>
        </div>
        <div class="text-right" v-if="hasReason">
          <small v-tooltip="'Contador de caracteres'">{{formData.motivo.length}} caracteres</small>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-4">
        <vs-input
          label="Plazo en días hábiles"
          type="number"
          v-model="formData.plazo"
          class="w-full"
          name="plazo"
          :danger="errors.has('custom-document.plazo')"
          :danger-text="errors.first('custom-document.plazo')"
          v-validate="'required'"
          data-cy="number"
        />
      </div>
    </div>
    <div class="form-group row">
      <label for="empresa" class="col-4 col-form-label">
        ¿Quiere escribir el motivo de la prórroga?
      </label>
      <div class="col-4">
        <select class="form-control" v-model="formData.esMotivoDeProrroga">
          <option value="si">Si</option>
          <option value="no">No</option>
        </select>
      </div>
    </div>

    <div class="form-group row" v-if="hasExtend">
      <div class="col-12">
        <label>Motivo de la prórroga </label>
        <vs-textarea
          type="text"
          class="w-full mb-0"
          v-model="formData.motivoProrroga"
          v-validate="'required'"
          name="motivoProrroga"
          data-vv-as="motivo de la prórroga"
          data-cy="reason-for-extension"
        />
        <div
          v-if="errors.first('custom-document.motivoProrroga')"
          class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
          style="height: 32px;">
        <span class="span-text-validation">
          {{errors.first('custom-document.motivoProrroga')}}
        </span>
        </div>
        <div class="text-right" v-if="hasReason">
          <small v-tooltip="'Contador de carácteres'">
            {{formData.motivoProrroga.length}} carácteres
          </small>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-10">
        <vs-input
          label="Con copia a"
          type="text"
          v-model="formData.copia"
          class="w-full"
          id="copia"
          data-cy="with-copy"
        />
      </div>
    </div>

    <div class="row justify-end">
      <vs-button

        class="mt-5 mr-5"
        @click="back()"
        color="primary"
        type="border"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button

        class="mt-5 mr-5"
        @click="save()"
        color="primary"
        type="border"
        :disabled="saving"
        data-cy="save"
      >
        Crear
        <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
      </vs-button>
    </div>
  </form>
</template>
<script>

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  name: 'ADP',
  props: {
  },
  data() {
    return {
      saving: false,
      formData: {
        empresa: 'aguasandinas',
        tituloDestinatario: 'sr',
        motivoProrroga: '',
        esMotivoDeProrroga: 'si',
        nombreDestinatario: 'Jorge Rivas Chaparro',
        cargoDestinatario: 'Superintendente de Servicios Sanitarios',
        nombreAutor: '',
        cargoAutor: '',
        materia: '',
        motivo: '',
        referencia: '',
        inc: '',
        copia: ''
      },
      extend: 'si'
    };
  },
  components: {
    ListUser
  },
  methods: {
    setPosition(user) {
      this.formData.cargoAutor = user.position || '';
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) {
        return;
      }
      if (!this.hasExtend) {
        this.formData.motivoProrroga = 'que las actividades que nos permitan dar una respuesta de '
          + 'calidad han tomado más tiempo de lo considerado.';
      }
      this.saving = true;
      this.$bvToast.toast(
        'Guardando documento',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      const personName = this.formData.nombreAutor
        ? this.$refs.author.getOption().label
        : '';
      const data = {
        ...this.formData,
        nombreAutor: personName
      };

      const response = await ioCreateCustomDocument({
        type: this.$route.params.type,
        query: this.$route.query,
        formData: data
      });
      console.log(response);
      await this.generatePdf(response.data.document.id);
      this.saving = false;
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('ADP', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    }
  },
  computed: {
    hasMatter() {
      return this.formData.materia.length > 0;
    },
    hasReason() {
      return this.formData.motivo.length > 0;
    },
    hasReference() {
      return this.formData.referencia.length > 0;
    },
    hasInc() {
      return this.formData.inc.length > 0;
    },
    hasExtend() {
      return this.formData.esMotivoDeProrroga === 'si';
    }
  }
};
</script>
